// webpack 5: re-export ค่าจริงแทน `export * from json` (ที่ทำให้ binding เป็น namespace)
import provincesData from './provinces.json'
export const provinces = provincesData.provinces

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY

export const GOOGLE_MAP_API_URL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_API_KEY}`

export const GOOGLE_MAP_STATIC_URL = `https://maps.googleapis.com/maps/api/staticmap?center={LOCATION}&zoom=12&size=400x100&maptype=roadmap&markers=color:red%7C{LOCATION}&key=${GOOGLE_API_KEY}`

export const HeroType = {
  RECYCLE_SHOP: {
    title: 'ร้านรับซื้อขยะรีไซเคิล'
  },
  SCOOTER: {
    title: 'รถรับซื้อขยะรีไซเคิลถึงที่'
  },
  DROP_POINT: {
    title: 'จุดรับบริจาคขยะรีไซเคิล'
  },
  POSTAL: {
    title: 'รับขยะรีไซเคิลทางพัสดุ'
  },
  CIRCULAR_BIN: {
    title: 'Circular Bin'
  },
  FACTORY: {
    title: 'โรงงานรีไซเคิล'
  }
}

export const PODType = {
  ON_DELIVERY: {
    title: 'จัดส่งสินค้า'
  },
  CONFIRM_PENDING: {
    title: 'รอยืนยันส่งจากผู้ซื้อ'
  },
  ON_RESERVE: {
    title: 'จองส่งสินค้า'
  },
  RESERVE_ACTIVE: {
    title: 'รอจัดส่ง (การจองครบจำนวน)'
  },
  CONFIRM_SENT: {
    title: 'รอจัดส่ง (ได้รับยืนยันส่งจากผู้ซื้อ)'
  },
  CONFIRM_CANCEL: {
    title: 'ยกเลิก (การยืนยันส่ง)'
  },
  ARRIVE_CHECK: {
    title: 'ยืนยันน้ำหนักรับ'
  },
  ARRIVE_PASS: {
    title: 'ส่งเอกสารการเงิน'
  },
  INVOICE_SEND: {
    title: 'รอรับโอนเงิน'
  },
  CASH_DELIVER: {
    title: 'ยืนยันรับเงิน'
  },
  DONE: {
    title: 'เสร็จสิ้น'
  },
  CANCEL_BUYER: {
    title: 'ยกเลิกโดยผู้ซื้อ'
  },
  CANCEL_SELLER: {
    title: 'ยกเลิกโดยผู้ขาย'
  },
  CANCEL_RESERVE: {
    title: 'ยกเลิกการจอง'
  },
  TIMEOUT: {
    title: 'หมดเวลา'
  }
}

export const CoinType = {
  CREATED_ANNOUNCEMENT: {
    title: 'สร้างประกาศโฆษณา'
  },
  BUY_COIN: {
    title: 'ซื้อเหรียญ'
  },
  CREATED_PO: {
    title: 'สร้าง PO'
  },
  CREATED_POD: {
    title: 'สร้าง POD'
  },
  REFUND_COIN_POD_DONE: {
    title: 'คืนเหรียญจากการส่ง POD สำเร็จ'
  },
  REFUND_COIN_PO_RESERVE_CANCEL: {
    title: 'คืนเหรียญ PO เนื่องจากไม่ครบจำนวนการจองและหมดเวลาจอง'
  },
  REFUND_COIN_POD_RESERVE_CANCEL: {
    title: 'คืนเหรียญ POD จากการจองถูกยกเลิก เนื่องจากไม่ครบจำนวนการจองและหมดเวลาจอง'
  },
  REFUND_COIN_POD_CANCEL: {
    title: 'คืนเหรียญ POD เนื่องจากผู้สร้าง PO ยกเลิกการจองของคุณ'
  },
  REFUND_COIN_POD_CONFIRM_CANCEL: {
    title: 'คืนเหรียญ POD เนื่องจากผู้สร้าง PO ยืนยันไม่รับสินค้า'
  }
}

export const DEFAULT_LOCATION = {
  lat: 18.79108,
  lng: 98.9833963
}
